import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../authSlice';
import { Navigate, Outlet } from 'react-router-dom';

export const RequireClientesEnabled = () => {
  const user = useSelector(selectCurrentUser);

  if (!user) return <Navigate to="/login" replace />;
  if (!user.clientes_enabled) return <Navigate to="/perfil" replace />;

  return <Outlet />;
}; 